// src/views/admin/settings/item-categories/component/DataTable.jsx
import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound   from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck     from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleModelOpen,
  deleteRecord,
}) => (
  <TableWrapServerSide
    tableColumnList={tableColumn}
    totalDataCount={totalRecord}
    initialPage={dataFilter?.page}
    onChangePage={onChangePage}
    per_page={dataFilter?.limit}
  >
    {dataSource.length ? (
      dataSource.map((cat) => (
        <tr className="db-table-body-tr" key={cat._id}>
          {/* Name */}
          <td className="db-table-body-td">{cat.name}</td>

          {/* Nature */}
          <td className="db-table-body-td capitalize">{cat.nature || '–'}</td>

          {/* Perishable? now always Yes/No */}
          <td className="db-table-body-td">
            {cat.isPerishable
              ? <span className="text-emerald-600">Yes</span>
              : <span className="text-gray-500">No</span>}
          </td>

          {/* Track stock */}
          <td className="db-table-body-td">
            {cat.trackInventory
              ? <span className="text-emerald-600">Yes</span>
              : <span className="text-gray-500">No</span>}
          </td>

          {/* Status */}
          <td className="db-table-body-td">
            {cat.status === 1
              ? <span className="active">Active</span>
              : <span className="inactive">Inactive</span>}
          </td>

          {/* Actions */}
          <td className="db-table-body-td hidden-print hidden-print-remove">
            <PermissionCheck permission="update_settings">
              <div className="flex gap-1.5">
                <button className="db-table-action edit" onClick={() => handleModelOpen(cat._id)}>
                  <i className="lab lab-edit-line" /><span className="db-tooltip">edit</span>
                </button>
                <button className="db-table-action delete" onClick={() => deleteRecord(cat._id)}>
                  <i className="lab lab-delete" /><span className="db-tooltip">delete</span>
                </button>
              </div>
            </PermissionCheck>
          </td>
        </tr>
      ))
    ) : (
      <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
    )}
  </TableWrapServerSide>
);

export default DataTable;
